<template>
    <div class="card mb-25 border-0 rounded-0 bg-white create-role-box">
      <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
        <form @submit.prevent="updateTaskType">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Task Name
                </label>
                <input
                  v-model="taskType.taskName"
                  type="text"
                  class="form-control shadow-none rounded-0 text-black"
                  placeholder="e.g. Administrator"
                  required
                />
              </div>
            </div>
            <div class="col-md-12">
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit"
              >
                Update Task Type
              </button>
  
              <button @click="goToMainMenu" class="default-btn transition border-0 fw-medium text-white 
                pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 
                fs-md-15 fs-lg-16 m-5 bg-danger" type="button"> Cancel </button>
                </div>
          </div>
        </form>
      </div>
    </div>
  </template>
    
    <script>
    import { ref, defineComponent, onMounted} from 'vue';
    import { useRoute, useRouter } from "vue-router";
    import { UpdateTaskType, FindTaskTypeByID } from '@/core/services/entities/task.service'
    import { useToast } from 'vue-toastification'
  
    export default defineComponent({
      name: 'UpdateTaskType',
      
      setup() {
        const route = useRoute();
        const router = useRouter();
        const taskTypeId = ref(0);
        const taskType=ref({});

        onMounted(async () => {
            taskTypeId.value = route.params.id;
          await findTaskTypeByID();
        });

        const goToMainMenu = async () => {
          router.push({ name: "TaskTypeListPage" });
        };

        const findTaskTypeByID = async () => {
          const response = await FindTaskTypeByID(taskTypeId.value);
          taskType.value = response.taskType;
        };

        const updateTaskType = async () => {
          const toast = useToast();
  
          try {
                const payload = { 
                  id: taskType.value.id,
                  customFieldName:taskType.value.taskName,
                };
                
                let response = await UpdateTaskType(payload);  
                if (response.status === 200) {
                  toast.success('Task type updated successfully!', {
                    timeout: 2000,
                  });
                  goToMainMenu();
                }
              } catch (ex) {
                const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                toast.error(`Failed to update task type: ${errorMessage}`, {
                  timeout: 2000,
                });
              }
    
        };
  
        return {
          taskTypeId,
          taskType,
          goToMainMenu,
          updateTaskType
        };
      }
    });
    </script>
  
    